/** Stale time constants — reuse these instead of hardcoding ms values */
export const STALE_TIME = {
  REAL_TIME: 0,
  BRIEF: 1000 * 30, // 30 seconds — re-read on focus, but at most twice a minute
  SHORT: 1000 * 60 * 2, // 2 minutes
  MEDIUM: 1000 * 60 * 5, // 5 minutes (default)
  LONG: 1000 * 60 * 30, // 30 minutes
  STATIC: Infinity, // Never refetch (e.g., enums, categories)
} as const
